import { createRootRoute, Outlet, useRouter } from '@tanstack/react-router';
import { Button } from '@/components';

/**
 * The root route. It renders the outlet and owns the two screens that are not a section:
 * not found and not authorized. The shell, the sidebar and the lock screen live below it.
 */
function RootError({ error }: { error: Error }) {
  const router = useRouter();
  return (
    <div className="o-center">
      <h1 className="o-page-title">Something broke on this screen</h1>
      <p className="o-muted">{error.message}</p>
      <Button variant="primary" onClick={() => void router.invalidate()}>
        Try again
      </Button>
    </div>
  );
}

function NotFound() {
  return (
    <div className="o-center">
      <h1 className="o-page-title">That page does not exist</h1>
      <p className="o-muted">
        Check the link. Deep links from Slack are stable, so a broken one usually means the
        object was removed.
      </p>
      <a className="o-btn o-btn--primary" href="/">
        Back to Home
      </a>
    </div>
  );
}

export const Route = createRootRoute({
  component: Outlet,
  errorComponent: RootError,
  notFoundComponent: NotFound,
});
